import { Chip as MuiChip } from "@mzc-pdc/ui";
import theme from "@styles/theme";

const Chip = ({ children, disableHover = false, ...props }) => {
    const hoverStyles = disableHover
        ? {
              "&.MuiChip-root.MuiChip-outlined:hover": {
                  backgroundColor: `${theme.palette.common.white} !important`,
              },
              "&.MuiChip-root.MuiChip-clickable.MuiChip-outlined:hover": {
                  backgroundColor: `${theme.palette.common.white} !important`,
              },
              "&.MuiChip-root:hover": {
                  backgroundColor: `${theme.palette.common.white} !important`,
              },
              "&:hover": {
                  backgroundColor: `${theme.palette.common.white} !important`,
              },
              transition: "none !important",
              "& *": {
                  transition: "none !important",
              },
          }
        : {};

    return (
        <MuiChip
            {...props}
            sx={{
                ...hoverStyles,
                ...props.sx,
            }}
        >
            {children}
        </MuiChip>
    );
};

export default Chip;
